import request from '../utils/request'
import qs from 'qs'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

export async function getInfor (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/permissionTemplate/getByTeamCode?teamCode=${teamCode}`)
}

export async function getAccountInfo (id) {
  return request(`${apiHetaoDomain}/staff/v1/account/${id}`)
}

export async function changeTeam (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/agent/changeTeam?${qs.stringify(params)}`)
}

export async function login (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/agent/login?${qs.stringify(params)}`)
}

export async function savePassword (params) {
  return request(`${apiHetaoDomain}/staff/v1/user/update/password`, params)
}

// 上传图片，获取签名

export function getSignature() {
  return request(`${apiHetaoDomain}/md-growth/v1/uploader/signature?type=imgHetao`)
}

export function searchBystaffName() {
  return request(`${apiHetaoDomain}/staff/v1/staffInfo?pageNum=1&pageSize=5000`)
}

// 获取单个人员工信息

export function getStaff(staffId) {
  return request(`${apiHetaoDomain}/staff/unauth/v1/extraInfo/account/${staffId}`)
}

export function getCode(phoneNumber) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/agent/verificationCode?phone=${phoneNumber}`)
}
